import {getCandleInterval, processCommand} from "./helpers.js";

class Command {

    constructor(onCursorMove) {
        this.onCursorMove = onCursorMove;
    }

    /**
     * @returns {
           @string position
           @string text
           @function click
       }
     * @description returns the ContextMenuItem in the required format by TradingView library
     *
     */
    getContextMenuItem() { return {}; }

    /**
     *
     * @param widget
     * @description accept the TradingView widget and add buttons to the header (mobile only)
     */
    createWidgetButton(widget) { return {}; }

    /**
     *
     * @returns the command bot command
     */
    getBotCommand() { return {}; }

    /**
     * pass the selected props to the insights app to handle trade window
     */
    sendToInsightsApp() {}

    /**
     * definition of the command (used for button label)
     */
    getCommandDef() {}
}

class CandleTrade extends Command {

    constructor(onCursorMove, currency, tradeSide, candleInterval, icon) {

        super(onCursorMove);

        this.currency = currency;
        this.tradeSide = tradeSide;
        this.candleInterval = candleInterval;
        this.icon = icon;
    }

    getContextMenuItem(cursor = this.onCursorMove) {
        return {
            position: "top",
            text: this.getCommandDef(),
            click: () => this.sendToInsightsApp(cursor)
        }
    }

    createWidgetButton(widget) {
        let button = widget.createButton();
        button.textContent = `${this.tradeSide}`;
        button.setAttribute('title', button.textContent);
        button.addEventListener('click', () => {
            this.sendToInsightsApp();
        });
    }

    getBotCommand() {

        const space = "%20";
        const date = new Date(this.onCursorMove.time * 1000);

        const pad = (n) => n.toString().padStart(2, '0');

        const formattedDate =
            pad(date.getUTCDate()) + '-' +
            pad(date.getUTCMonth() + 1) + ' ' +
            pad(date.getUTCHours()) + ':' +
            pad(date.getUTCMinutes());

        const bcst = formattedDate.replace(' ' , space);

        return {
            command: `candleTrade ts ${this.tradeSide} c ${this.currency} eci ${getCandleInterval(this.candleInterval)} bcst ${bcst}`
        }
    }

    sendToInsightsApp(cursor = this.onCursorMove) {
        const selectedCandle = cursor?.selectedCandle || window.__insightsCandleAt?.(
            `${this.currency}USDT`, this.candleInterval, cursor?.time
        ) || null;
        const data = {
            currency: this.currency,
            tradeSide: this.tradeSide,
            date: new Date(cursor.time * 1000),
            candle:  getCandleInterval(this.candleInterval),
            price: cursor?.price?.toFixed(7) + "$",
            selectedCandle
        };

        window.dispatchEvent(new CustomEvent('trade_window', { detail: data }));
    }

    getCommandDef() {
        return this.tradeSide;
    }
}

class PricePick extends Command {

    constructor(onCursorMove, currency, pickerField, icon) {

        super(onCursorMove);

        this.currency = currency;
        this.pickerField = pickerField;
        this.icon = icon;
    }

    getContextMenuItem(cursor = this.onCursorMove) {
        return {
            position: "top",
            text: this.getCommandDef(),
            click: () => this.sendToInsightsApp(cursor)
        }
    }

    createWidgetButton(widget) {
        let button = widget.createButton();
        button.textContent = "PICK";
        button.setAttribute('title', button.textContent);
        button.addEventListener('click', () => {
            this.sendToInsightsApp();
        });
    }

    sendToInsightsApp(cursor = this.onCursorMove) {

        if (!Number.isFinite(cursor?.price)) return;

        const data = {
            currency: this.currency,
            pickerField: this.pickerField,
            price: cursor.price.toFixed(7) + "$",
        };

        if (window.parent === window) {
            window.dispatchEvent(new CustomEvent('pick_price', { detail: data }));
        } else {
            window.parent.postMessage({ type: 'pick_price', data }, window.location.origin);
        }
    }

    getCommandDef() {
        return "PICK";
    }
}

class TpSl extends CandleTrade {

    constructor(onCursorMove, currency, interval, icon) {

        super(onCursorMove);

        this.currency = currency;
        this.candleInterval = interval;
        this.icon = icon;
    }

    getContextMenuItem(cursor = this.onCursorMove) {
        return {
            position: "top",
            text: this.getCommandDef(),
            click: () => this.sendToInsightsApp(cursor)
        }
    }

    createWidgetButton(widget) {
        let button = widget.createButton();
        button.textContent = this.getCommandDef();
        button.setAttribute('title', button.textContent);
        button.addEventListener('click', () => {
            this.sendToInsightsApp();
        });
    }

    sendToInsightsApp(cursor = this.onCursorMove) {

        const data = {
            currency: this.currency,
            price: cursor?.price?.toFixed(7) + "$",
            tradeSide: "LONG",
            interval : getCandleInterval(this.candleInterval)
        };

        window.dispatchEvent(new CustomEvent('tpsl', { detail: data }));
    }

    getCommandDef() {
        return "TP/SL";
    }
}

class Notify extends Command {

    constructor(onCursorMove, currency, icon) {
        super(onCursorMove);
        this.currency = currency;
        this.icon = icon;
    }

    getContextMenuItem(cursor = this.onCursorMove) {
        return {
            position: "top",
            text: this.getCommandDef(),
            click: () => this.sendToInsightsApp(cursor)
        }
    }

    createWidgetButton(widget) {
        let button = widget.createButton();
        button.textContent = "NOTIFY";
        button.setAttribute('title', button.textContent);
        button.addEventListener('click', () => this.sendToInsightsApp());
    }

    getBotCommand(cursor = this.onCursorMove) {
        return {
            command: `priceNotify c ${this.currency} p ${cursor.price}`
        }
    }

    getCommandDef() {
        return "NOTIFY";
    }

    sendToInsightsApp(cursor = this.onCursorMove) {
        processCommand(this.getBotCommand(cursor));
    }

}

export { Command, CandleTrade, Notify, PricePick, TpSl };
